import React from 'react'
import Calendar from './Calender'
import { Header } from '../../../components/page-header/Header'
import { useTranslation } from 'react-i18next';
const HijriCalender = () => {
    const { t } = useTranslation();
    const breadcrumbItems = [
        { label: t("universal_dashboard_text"), to: '/user-dashboard' },
        { label: 'Hijri Calendar' },
    ];


    return (
        <>
            <section className="min-h-[86vh] bg-gradient-to-b from-slate-50 to-gray-50">
                <div className="max-w-7xl mx-auto p-6">
                    <div className="space-y-6">

                        <div className="flex items-center justify-between">
                            <Header title={t("hijri_calendar_title")} breadcrumbItems={breadcrumbItems} />
                        </div>

                        <div className="w-full">
                            <Calendar />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HijriCalender
